import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  reset() {
    // Small delay to let the drawer start opening
    setTimeout(() => {
      this.element.scrollTo({
        left: 0,
        behavior: 'smooth'
      })
    }, 100)
  }
}